"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./nodejsShims");
var _KatalMetricsDriverSushi = require("./KatalMetricsDriverSushi");
/* istanbul ignore file */
var _default = exports.default = _KatalMetricsDriverSushi.KatalMetricsDriverSushi;